import { siteService } from "../services";

export const sites = {
  namespaced: true,
  state: {
    sites: []
  },
  mutations: {
    GET_SITES(state, sites) {
      state.sites = sites;
    },
    ADD_SITE(state, site) {
      state.sites.unshift(site);
    },
    REMOVE_SITE(state, id) {
      let sites = state.sites;
      let index = sites.findIndex(x => x.id == id);
      if ( index >  -1) {
          sites.splice(index, 1);
      }
    },
    REMOVE_BUILDING(state, { site, building }) {
      let sites = state.sites;
      let siteIndex = sites.findIndex(x => x.id == site);
      if ( siteIndex >  -1) {
        let currentSite = sites[siteIndex];
        let buildings = currentSite.buildings;
        let buildingIndex = buildings.findIndex(x => x.id == building);
        if ( buildingIndex >  -1) {
          buildings.splice(buildingIndex, 1);
        }
      }
    },
    ADD_BUILDING(state, { site , building }) {
        let sites = state.sites;
        let siteIndex = sites.findIndex(x => x.id == site);
        if ( siteIndex >  -1) {
            let currentSite = sites[siteIndex];
            let buildings = currentSite.buildings;
            buildings.push(building);
        }
    },
  },
  actions: {
    getSites({ dispatch, commit }) {
        dispatch("alert/loadingOn", "",  { root: true });
        return siteService.getSites().then(
            result => {
                if (result.data) {
                    let sites = result.data.sites.reverse();
                    commit("GET_SITES", sites);
                } else {
                    commit("GET_SITES", []);
                }
                dispatch("alert/loadingOff", "", { root: true });
            },
            error => {
                dispatch("alert/error", error, { root: true });
                dispatch("alert/loadingOff", "", { root: true });
            }
        );
    },
    add({ dispatch, commit }, { address, latitude, longitude }) {
      dispatch("alert/loadingOn", "", { root: true });
      return siteService.addSite({ address, latitude, longitude }).then(
        site => {
          commit("ADD_SITE", site.data);
          dispatch("alert/success", "Your site has been added!", { root: true });
          dispatch("alert/loadingOff", "", { root: true });
        },
        error => {
          dispatch("alert/error", error, { root: true });
          dispatch("alert/loadingOff", "", { root: true });
        }
      );
    },
    delete({ dispatch, commit }, { site }) {
      dispatch("alert/loadingOn", "",  { root: true });
      siteService.deleteSite({ site }).then(
        result => {
          commit("REMOVE_SITE", site);
          dispatch("alert/success", "Your site has been deleted!", { root: true });
          dispatch("alert/loadingOff", "", { root: true });
        },
        error => {
          dispatch("alert/error", error, { root: true });
          dispatch("alert/loadingOff", "", { root: true });
        }
      );
    },
    saveSite({ dispatch }, { site }) {
        dispatch("alert/loadingOn", "",  { root: true });
        siteService.editSite({ site }).then(
            result => {
                dispatch("alert/success", "Your site has been saved", { root: true });
                dispatch("alert/loadingOff", "", { root: true });
            },
            error => {
                dispatch("alert/error", error, { root: true });
                dispatch("alert/loadingOff", "", { root: true });
            }
        );

    },
    submitSite({ dispatch }, { site }) {
      dispatch("alert/loadingOn", "",  { root: true });
      return siteService.submitSite({ site }).then(
          result => {
              dispatch("alert/success", "Your site has been submitted!", { root: true });
              dispatch("alert/loadingOff", "", { root: true });
          },
          error => {
              dispatch("alert/error", error, { root: true });
              dispatch("alert/loadingOff", "", { root: true });
          }
      );

    },
    addBuilding({ dispatch, commit }, { site  }) {
        dispatch("alert/loadingOn", "",  { root: true });
        siteService.addBuilding({ site }).then(
            result => {
                const data = { site: site, building: result.data}
                commit("ADD_BUILDING",  data );
                dispatch("alert/success", "Your building has been added", { root: true });
                dispatch("alert/loadingOff", "", { root: true });
            },
            error => {
                dispatch("alert/error", error, { root: true });
                dispatch("alert/loadingOff", "", { root: true });
            }
        );
    },
    deleteBuilding({ dispatch, commit }, { site, building }) {
        dispatch("alert/loadingOn", "",  { root: true });
        siteService.deleteBuilding({ building }).then(
            result => {
                commit("REMOVE_BUILDING", { site, building });
                dispatch("alert/success", "Your building has been deleted", { root: true });
                dispatch("alert/loadingOff", "", { root: true });
            },
            error => {
                dispatch("alert/error", error, { root: true });
                dispatch("alert/loadingOff", "", { root: true });
            }
        );
    },
    saveBuilding({ dispatch, commit }, { building }) {
        dispatch("alert/loadingOn", "",  { root: true });
        siteService.editBuilding({ building }).then(
            result => {
                dispatch("alert/success", "Your building has been saved", { root: true });
                dispatch("alert/loadingOff", "", { root: true });
            },
            error => {
                dispatch("alert/error", error, { root: true });
                dispatch("alert/loadingOff", "", { root: true });
            }
        );
    }
  },
  getters: {
    sites: state => state.sites
  }
};
